import { __extends } from "tslib";
import { ErrorEvent } from './ErrorEvent';
var UncaughtErrorEvent = /** @class */ (function (_super) {
    __extends(UncaughtErrorEvent, _super);
    function UncaughtErrorEvent(type, bubbles, cancelable, error_in) {
        if (type === void 0) { type = 'uncaughtError'; }
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = true; }
        if (error_in === void 0) { error_in = null; }
        return _super.call(this, type, bubbles, cancelable, error_in) || this;
    }
    UncaughtErrorEvent.classInitializer = null;
    UncaughtErrorEvent.classSymbols = null;
    UncaughtErrorEvent.instanceSymbols = null;
    // JS -> AS Bindings
    UncaughtErrorEvent.UNCAUGHT_ERROR = 'uncaughtError';
    return UncaughtErrorEvent;
}(ErrorEvent));
export { UncaughtErrorEvent };
